import React from "react";
import { useForm } from "react-hook-form";
import Client from "../../../utils/client";
import { api_url } from "../../../constant";
import { toast } from "react-toastify";

function ChangePassword() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onSubmit", reValidateMode: "onSubmit" });

  const onSubmit = async (data) => {
    if (data.newPassword !== data.reNewPassword) {
      return toast("كلمة المرور الجديدة غير متطابقة", { type: "error" });
    }

    if (data.newPassword.length < 6) {
      return toast("يجب ان تتكون كلمة المرور من 6 أحرف على الاقل", {
        type: "error",
      });
    }

    if (
      data.newPassword === data.reNewPassword &&
      data.newPassword === data.password
    ) {
      return toast(" كلمة المرور القديمة والجديدة متشايهة", {
        type: "error",
      });
    }

    const _data = { password: data.password, newPassword: data.newPassword };
    const res = await Client.post(api_url + "/users/change-password", _data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(() => {
        localStorage.removeItem("token");
        window.location.reload();
      })
      .catch((err) => {
        if (err.response.status === 400) {
          toast("كلمة المرور القديمة خاطئة", { type: "error" });
        }
      });
  };
  return (
    <div className="my-10 px-5 lg:px-7" dir="rtl">
      <h1 className="lg:text-start font-bold text-xl lg:text-[24px] my-14 lg:my-10">
        تغيير كلمة المرور
      </h1>
      <form
        onSubmit={handleSubmit(onSubmit)}
        dir="rtl"
        className="flex flex-col gap-3 lg:w-[30%] lg:mr-24"
      >
        <div className="flex flex-col gap-3">
          <label htmlFor="oldPassword" className="font-bold text-sm">
            كلمة المرور القديمة
          </label>
          <input
            type="password"
            name="oldPassword"
            className="rounded-lg focus:ring-0 focus:border-primary placeholder:text-sm"
            placeholder="إدخل كلمة المرور القديمة"
            {...register("password", { required: true })}
          />
        </div>
        <div className="flex flex-col gap-3">
          <label htmlFor="newPassword" className="font-bold text-sm">
            كلمة المرور الجديدة
          </label>
          <input
            type="password"
            name="newPassword"
            className="rounded-lg focus:ring-0 focus:border-primary placeholder:text-sm"
            placeholder="إدخل كلمة المرور الجديدة"
            {...register("newPassword", { required: true })}
          />
        </div>
        <div className="flex flex-col mt-3">
          <input
            type="password"
            name="reNewPassword"
            className="rounded-lg focus:ring-0 focus:border-primary placeholder:text-sm"
            placeholder="أكد كلمة المرور الجديدة"
            {...register("reNewPassword", { required: true })}
          />
        </div>

        <button
          type="submit"
          className="w-full text-white bg-primary py-2 mt-3 rounded-lg"
        >
          تأكيد
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
